// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4943":"css/admin-app.6884","7988":"css/app.6884"}[chunkId] + ".css";
};